import { ResourceDetail, ResourceListResponse } from "@rossum/upcloud-costs-shared";

import { getJson } from "./http-client";

export function fetchResources(query: {
    from: string;
    to: string;
    unassignedOnly: boolean;
}): Promise<ResourceListResponse> {
    return getJson<ResourceListResponse>("/api/resources", {
        from: query.from,
        to: query.to,
        unassignedOnly: String(query.unassignedOnly),
    });
}

export function fetchResource(cloudResourceId: string): Promise<ResourceDetail> {
    return getJson<ResourceDetail>(`/api/resources/${encodeURIComponent(cloudResourceId)}`);
}
